import {validacion} from 'lib.common';
import {cmps} from './constantes';

export const esquemaCampos = {
   [cmps.CLIENTE]: {valor: null, error: ''},
   [cmps.RAZON_SOCIAL]: {valor: '', error: ''},
   [cmps.EMAIL]: {valor: '', error: ''}
};

export const esquemaValidacion = {
   [cmps.CLIENTE]: {
      requerido: true
   },
   [cmps.EMAIL]: {
      requerido: true,
      validador: {
         regla: validacion.esCorreoValido,
         error: 'Correo electrónico no válido.'
      }
   }
};
